import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { cloneDeep } from 'lodash';
import usePostHogFeatureFlagWithPayload from 'hooks/usePostHogFeatureFlag/usePostHogFeatureFlagWithPayload';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
import DesktopNavClearance from 'components/nav/DesktopHeader/components/DesktopNavClearance';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import desktopStaticNavItems from './desktopStaticNavItems';
const useDesktopNavItems = () => {
  const $ = _c(14);
  const [customSaleNavMenuFeatureFlag, customSaleNavMenuFeatureFlagPayload] = usePostHogFeatureFlagWithPayload("customSaleNavMenu");
  const {
    promotionData
  } = useContentfulPromotionContent();
  let t0;
  if ($[0] !== customSaleNavMenuFeatureFlag || $[1] !== customSaleNavMenuFeatureFlagPayload?.ctaUrl || $[2] !== customSaleNavMenuFeatureFlagPayload?.items || $[3] !== customSaleNavMenuFeatureFlagPayload?.url || $[4] !== promotionData?.saleDropdownAuxPromoUrl) {
    t0 = customSaleNavMenuFeatureFlag === "customized" ? {
      url: customSaleNavMenuFeatureFlagPayload?.url,
      ctaUrl: customSaleNavMenuFeatureFlagPayload?.ctaUrl,
      items: customSaleNavMenuFeatureFlagPayload?.items
    } : customSaleNavMenuFeatureFlag === "contentful" ? {
      url: promotionData?.saleDropdownAuxPromoUrl,
      ctaUrl: promotionData?.saleDropdownAuxPromoUrl
    } : {};
    $[0] = customSaleNavMenuFeatureFlag;
    $[1] = customSaleNavMenuFeatureFlagPayload?.ctaUrl;
    $[2] = customSaleNavMenuFeatureFlagPayload?.items;
    $[3] = customSaleNavMenuFeatureFlagPayload?.url;
    $[4] = promotionData?.saleDropdownAuxPromoUrl;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const salesMenuOverrides = t0;
  promotionData?.displayFlashSale;
  promotionData?.saleDropdownAuxPromoText;
  promotionData?.saleDropdownAuxPromoUrl;
  promotionData?.saleDropdownMedia;
  salesMenuOverrides?.url;
  salesMenuOverrides?.ctaUrl;
  salesMenuOverrides?.items;
  let updatedItems;
  if ($[6] !== promotionData?.displayFlashSale || $[7] !== promotionData?.saleDropdownAuxPromoText || $[8] !== promotionData?.saleDropdownAuxPromoUrl || $[9] !== promotionData?.saleDropdownMedia || $[10] !== salesMenuOverrides?.ctaUrl || $[11] !== salesMenuOverrides?.items || $[12] !== salesMenuOverrides?.url) {
    updatedItems = cloneDeep(desktopStaticNavItems);
    const joybirdDesignHouseGroup = updatedItems.find(_temp);
    const freeDesignServicesItem = joybirdDesignHouseGroup ? joybirdDesignHouseGroup.items.find(_temp2) : null;
    if (freeDesignServicesItem) {
      freeDesignServicesItem.label = "Free Design Services";
    }
    const saleCategory = updatedItems.find(_temp3);
    if (saleCategory) {
      saleCategory.image = promotionData?.saleDropdownMedia || saleCategory.image;
    }
    const flashSaleItem = promotionData?.displayFlashSale ? {
      label: "Flash Sale",
      id: "flash-sale",
      url: "/flash-sale/"
    } : null;
    saleCategory.url = salesMenuOverrides?.url ?? "/sale/";
    saleCategory.ctaUrl = salesMenuOverrides?.ctaUrl ?? "/sale/";
    saleCategory.items = [...(salesMenuOverrides?.items ?? []), {
      label: "Clearance",
      id: "clearance",
      url: "/clearance/",
      customContent: <DesktopNavClearance />
    }, flashSaleItem].filter(_temp4);
    if (promotionData?.saleDropdownAuxPromoText && promotionData?.saleDropdownAuxPromoUrl) {
      saleCategory.items = [{
        label: <SanitizedHtml as="span" html={promotionData?.saleDropdownAuxPromoText} />,
        id: "aux-promo-link",
        url: `${promotionData?.saleDropdownAuxPromoUrl}`
      }, ...saleCategory.items];
    }
    $[6] = promotionData?.displayFlashSale;
    $[7] = promotionData?.saleDropdownAuxPromoText;
    $[8] = promotionData?.saleDropdownAuxPromoUrl;
    $[9] = promotionData?.saleDropdownMedia;
    $[10] = salesMenuOverrides?.ctaUrl;
    $[11] = salesMenuOverrides?.items;
    $[12] = salesMenuOverrides?.url;
    $[13] = updatedItems;
  } else {
    updatedItems = $[13];
  }
  const categoryNavItems = updatedItems;
  return categoryNavItems;
};
export default useDesktopNavItems;
function _temp(item) {
  return item.id === "joybird-design-house";
}
function _temp2(item_0) {
  return item_0.id === "free-design-services";
}
function _temp3(t0) {
  const {
    id
  } = t0;
  return id === "sale";
}
function _temp4(item_1) {
  return !!item_1;
}